import { IGetAllServicoProdutoUseCase } from "../../../presentation/useCases/read/get_all_servico_produto_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";
import { ServicoProdutoLista } from "../../models/servico_produto_lista";

/**
 * GetAllServicoProdutoUseCase
 */

export class GetAllServicoProdutoUseCase extends BasePaginatedUseCase<ServicoProdutoLista> implements IGetAllServicoProdutoUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllServicoProduto(
    field: number | null,
    fieldValue: string | null,
    tipo: number | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllServicoProduto(
      field,
      fieldValue,
      tipo,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
